import { render, staticRenderFns } from "./DocumentSelect.vue?vue&type=template&id=0a55bf4e&scoped=true"
import script from "./DocumentSelect.vue?vue&type=script&lang=js"
export * from "./DocumentSelect.vue?vue&type=script&lang=js"
import style0 from "./DocumentSelect.vue?vue&type=style&index=0&id=0a55bf4e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a55bf4e",
  null
  
)

export default component.exports